// src/theme/theme.js
/*
import { extendTheme } from '@chakra-ui/react';

const customTheme = extendTheme({
  colors: {
    black: '#000',
    brand: {
      50: '#ffe5f7',
      100: '#ffb3d8',
      200: '#ff80ba',
      300: '#ff4d9b',
      400: '#ff1a7d',
      500: '#e60063',
      600: '#b4004e',
      700: '#80003a',
      800: '#4d0025',
      900: '#1a0011',
    },
    // Add more custom colors or override the existing colors
    primary: {
      50: '#e7f5ff',
      100: '#d0ebff',
      200: '#a5d8ff',
      300: '#74c0fc',
      400: '#4dabf7',
      500: '#339af0',
      600: '#228be6',
      700: '#1c7ed6',
      800: '#1971c2',
      900: '#1864ab',
    },
  },
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
  },
});

export default customTheme;
*/

// theme.js

// 1. import `extendTheme` function
import { extendTheme, useColorModeValue } from '@chakra-ui/react'

// 2. Add your color mode config
const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
}

// 3. extend the theme
const theme = extendTheme({ config })

export default theme